import React from 'react';

const Certifications = ({ certifications }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-yellow-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Certifications</h3>
      </div>
      <div className="px-6 py-4">
        {certifications?.items && certifications.items.length > 0 ? (
          <div className="space-y-4">
            {certifications.items.map((cert, index) => (
              <div key={index} className="border-b border-gray-100 pb-3 last:border-b-0 last:pb-0">
                <h4 className="font-bold text-gray-800 mb-1">{cert.name}</h4>
                <p className="text-sm text-gray-700">Issued by: <span className="text-yellow-700">{cert.issuer}</span></p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 italic">No certifications listed</p>
        )}
      </div>
    </div>
  );
};

export default Certifications;
